var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid inherit-link-styles"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id},[_c('Row',{attrs:{"item":item}})],1)}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }